<script setup lang="ts">
const props = defineProps<{
  lat: number;
  lng: number;
  name: string;
}>();

const { t } = useI18n();

const links = computed(() => {
  const q = encodeURIComponent(props.name);
  const { lat, lng } = props;
  return [
    {
      key: "google",
      label: t("map.openIn.google"),
      href: `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,
    },
    {
      key: "apple",
      label: t("map.openIn.apple"),
      href: `https://maps.apple.com/?q=${q}&ll=${lat},${lng}`,
    },
    {
      key: "yandex",
      label: t("map.openIn.yandex"),
      href: `https://yandex.com/maps/?pt=${lng},${lat}&z=15&l=map`,
    },
    {
      key: "twogis",
      label: t("map.openIn.twogis"),
      href: `https://2gis.ge/geo/${lng},${lat}`,
    },
  ];
});
</script>

<template>
  <div class="mt-4">
    <p
      class="mb-2 text-xs font-body uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400"
    >
      {{ t("map.openIn.heading") }}
    </p>
    <div class="grid grid-cols-2 gap-2 sm:grid-cols-4">
      <a
        v-for="link in links"
        :key="link.key"
        :href="link.href"
        target="_blank"
        rel="noopener noreferrer"
        class="group inline-flex items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm transition-all hover:border-amber-400 hover:text-amber-600 hover:shadow-md dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:border-amber-400 dark:hover:text-amber-400"
      >
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          class="h-4 w-4 transition-transform group-hover:scale-110"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
        <span>{{ link.label }}</span>
      </a>
    </div>
  </div>
</template>
